export class News {

    public id: string = "0";
    public active: boolean;
    public created: Date;
    public image: string;
    public image_en: string
    public text: string;
    public text_en: string;
    public text_home: string;
    public text_home_en: string;
    public title: string;
    public title_en: string;

    
    constructor() {}
}